<template>
  <div>
    <v-card>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title>Períodos nas Cidades</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="add">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout px-4 wrap>
        <v-flex md12>
          <v-list two-line>
            <template v-for="(item, i) in data">
              <v-divider v-if="i > 0" :key="`divider_${i}`"></v-divider>
              <v-list-item ripple :key="`tile_${i}`" @click="edit(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.city }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.arrivalDate | moment("L") }} -
                    {{ item.departureDate | moment("L") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="isFormVisible" persistent max-width="550">
      <v-card>
        <v-card-title class="headline">Período na Cidade</v-card-title>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex md12>
              <v-text-field
                name="city"
                label="Cidade"
                id="city"
                v-model="formModel.city"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md12>
              <DatePicker
                name="arrivalDate"
                id="arrivalDate"
                label="Chegada"
                v-model="formModel.arrivalDate"
                required
              />
            </v-flex>
            <v-flex md12>
              <DatePicker
                name="departureDate"
                id="departureDate"
                label="Saída"
                v-model="formModel.departureDate"
                required
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            icon
            @click="confirmRemove(formModel)"
            v-if="this.formModel.id > 0"
            ><v-icon>delete</v-icon></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" text @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OperationStatusCard
      id="operationStatusCard"
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
    <ConfirmDialog
      id="confirmDeleteDialog"
      ref="confirmDeleteDialog"
      title="Excluir Registro"
      :message="`Deseja realmente excluir a cidade ${this.formModel.city}?`"
      yes-button="Sim"
      no-button="Não"
      @confirm="remove"
    />
  </div>
</template>
<script>
import api from "@/api";
import DatePicker from "@/components/Shared/DatePicker";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "StayManagement",
  components: {
    DatePicker,
    ConfirmDialog,
    OperationStatusCard
  },
  props: ["tripId"],
  data() {
    return {
      isFormVisible: false,
      formModel: {},
      isDataLoading: false,
      data: []
    };
  },
  methods: {
    add() {
      this.formModel = {};
      this.isFormVisible = true;
    },
    edit(obj) {
      this.formModel = obj;
      this.isFormVisible = true;
    },
    cancel() {
      this.isFormVisible = false;
      this.load();
    },
    save() {
      this.isFormVisible = false;
      this.$refs.operationStatusCard.show();
      var endpoint = this.formModel.id
        ? `/trips/${this.tripId}/stay/${this.formModel.id}`
        : `/trips/${this.tripId}/stay`;
      var method = this.formModel.id ? "PUT" : "POST";
      api
        .request(method, endpoint, this.formModel)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.load();
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    },
    confirmRemove(obj) {
      this.formModel = obj;
      this.$refs.confirmDeleteDialog.show();
    },
    remove() {
      this.isFormVisible = false;
      this.$refs.operationStatusCard.show();
      api
        .request("DELETE", `/trips/${this.tripId}/stay/${this.formModel.id}`)
        .then(() => {
          this.$refs.operationStatusCard.succeed();
          this.load();
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    },
    load() {
      if (this.tripId) {
        this.isDataLoading = true;
        api
          .request("GET", `/trips/${this.tripId}/stay`)
          .then(response => {
            this.data = response.data.stays;
            this.$emit("loaded", this.data);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.isDataLoading = false;
          });
      }
    }
  },
  mounted() {
    this.load();
  }
};
</script>
